import { render, staticRenderFns } from "./SsoHandler.vue?vue&type=template&id=7aeede4a&scoped=true&"
import script from "./SsoHandler.vue?vue&type=script&lang=js&"
export * from "./SsoHandler.vue?vue&type=script&lang=js&"
import style0 from "./SsoHandler.vue?vue&type=style&index=0&id=7aeede4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeede4a",
  null
  
)

export default component.exports